import { render } from "./TextInputPopup.vue?vue&type=template&id=3db8304b&scoped=true"
import script from "./TextInputPopup.vue?vue&type=script&lang=js"
export * from "./TextInputPopup.vue?vue&type=script&lang=js"

import "./TextInputPopup.vue?vue&type=style&index=0&id=3db8304b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8304b"]])

export default __exports__